export const content = {
  'designer.siteSnapshots.site-restore.notification.in-progress.title':
    'Site backup is in progress',
  'designer.siteSnapshots.site-restore.notification.in-progress.message.user':
    '{{userDisplayName}} is creating a backup for the current version of {{siteName}}.',
  'designer.siteSnapshots.site-restore.notification.in-progress.message.general':
    'A backup for the current version of {{siteName}} is being created.',
} as const;
